import React from 'react';
import { ComponentProps } from './ComponentProps';
import { useBiClickLogger } from '../hooks/useBiClickLogger';

const BiButton: React.FC<ComponentProps> = ({
  biData,
  innerRef,
  stopPropagation,
  disabled,
  ...props
}) => {
  const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
  return (
    <button
      /*
        Some screen readers don't pick up that a button is disabled
        when only `disable` is set, so use aria-disabled as well
      */
      disabled={disabled}
      aria-disabled={disabled}
      {...props}
      ref={node => {
        setTrackingRef(node);
        innerRef && innerRef(node);
      }}
    />
  );
};
BiButton.displayName = 'BiButton';

export default BiButton;
